import { useEffect, useRef, useState } from 'react';
import { CommunicationMessageEvents } from '../../interfaces/message-events';
import { useDontMountAtFirst } from '../../../shared/hooks/useDontMountAtFirst';

export function useDocsLoader({
  docLink,
  sendMessageToIframe,
  onIframeLoadError,
  onIframeLoadSuccess,
  loadMessage,
  loadedMessage
}: {
  docLink: string;
  loadMessage: CommunicationMessageEvents;
  loadedMessage: CommunicationMessageEvents;
  onIframeLoadError: VoidFunction;
  onIframeLoadSuccess: VoidFunction;
  sendMessageToIframe: (event: CommunicationMessageEvents, data: object) => void;
}) {
  const pollTimeoutRef = useRef<NodeJS.Timeout>(null!);
  const isIframeLoadingRef = useRef(true);
  const [error, setError] = useState(false);
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  useDontMountAtFirst(() => {
    setIsIframeLoading(true);
  }, [docLink]);

  useEffect(() => {
    isIframeLoadingRef.current = isIframeLoading;
  }, [isIframeLoading]);

  const onIframeLoadEvent = () => {
    sendMessageToIframe(loadMessage, {});

    if (pollTimeoutRef.current) {
      clearTimeout(pollTimeoutRef.current);
    }

    pollIframeLoadStatus();
  };

  const pollIframeLoadStatus = () => {
    let itr = 0;

    pollTimeoutRef.current = setInterval(() => {
      if (!isIframeLoadingRef.current) {
        clearTimeout(pollTimeoutRef.current);
        return;
      }

      if (itr === 6) {
        setIsIframeLoading(false);
        setError(true);

        onIframeLoadError();

        clearTimeout(pollTimeoutRef.current);

        return;
      }

      itr += 1;
    }, 5000);
  };

  const onMessageFromIframe = (e: { event: CommunicationMessageEvents; data: object }) => {
    if (e.event === loadedMessage) {
      setIsIframeLoading(false);
      onIframeLoadSuccess();
    }
  };

  const onIframeLoadErrorEvent = () => {
    setError(true);
  };

  return {
    error,
    isIframeLoading,
    isIframeLoadingRef,
    onIframeLoadEvent,
    onIframeLoadErrorEvent,
    onMessageFromIframe
  };
}
